import { render, staticRenderFns } from "./computingPower.vue?vue&type=template&id=369a5d04&scoped=true"
import script from "./computingPower.vue?vue&type=script&lang=js"
export * from "./computingPower.vue?vue&type=script&lang=js"
import style0 from "./computingPower.vue?vue&type=style&index=0&id=369a5d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a5d04",
  null
  
)

export default component.exports